var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.576,
    height: 196.926,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h113.543v113.543H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-378 -97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.393 117.402v49.675a.89.89 0 0 1-.887.887h-90.413a.89.89 0 0 1-.887-.887v-49.675a2.669 2.669 0 0 1 2.661-2.661h86.865a2.669 2.669 0 0 1 2.661 2.661z",
    fill: "#7fc4fd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ccc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 224.081h86.192v69.845H378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.192 195.35h86.192v98.576h-86.192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.384 249.344h86.192v44.582h-86.192z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(449.517 97)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.06 98.064a1.129 1.129 0 0 0-.932-.954l-4.945-.421c-2.617-.687-4.546-3.593-4.945-6.276l-.266-1.708h-20.4l-.266 1.685c-.421 2.683-2.329 5.588-4.945 6.276l-4.945.421a1.21 1.21 0 0 0-.931.954 1.137 1.137 0 0 0 1.131 1.286h40.317a1.121 1.121 0 0 0 1.131-1.264m26.811-82.319a5.357 5.357 0 0 0-3.77-1.552H12.463a5.318 5.318 0 0 0-3.77 1.552 5.4 5.4 0 0 0-1.6 3.77v60.32a5.361 5.361 0 0 0 1.6 3.77 5.254 5.254 0 0 0 3.726 1.552h88.705a5.216 5.216 0 0 0 3.725-1.552 5.4 5.4 0 0 0 1.6-3.77v-60.32a5.287 5.287 0 0 0-1.574-3.77m-48.1 64.09a1.774 1.774 0 1 1 1.774-1.774 1.779 1.779 0 0 1-1.774 1.774m45.218-8.871H11.576a.89.89 0 0 1-.887-.887V20.402a2.669 2.669 0 0 1 2.661-2.661h86.865a2.669 2.669 0 0 1 2.661 2.661v49.675a.89.89 0 0 1-.887.887"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M506.066 197.299l9.762 8.268 40.134-53.347v-5.545z",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456.613 146.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.777 50.624l-9.762 8.268L0 5.544V0z",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.488,
    cy: 12.488,
    r: 12.488,
    transform: "translate(37.341 46.431)",
    fill: "#fcee21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M511.55 204.764l-.052-.222h-4.839v2.048h2.891a2.893 2.893 0 0 1-2.83 2.175 3.385 3.385 0 0 1-2.278-.907 3.252 3.252 0 0 1-.97-2.3 3.354 3.354 0 0 1 .953-2.293 3.24 3.24 0 0 1 2.263-.885 2.952 2.952 0 0 1 1.925.75l1.455-1.448a5.149 5.149 0 0 0-3.428-1.32 5.133 5.133 0 0 0-5.231 5.2 5.225 5.225 0 0 0 1.423 3.613 5.428 5.428 0 0 0 3.913 1.588 4.827 4.827 0 0 0 3.516-1.478 5.192 5.192 0 0 0 1.35-3.6 5.946 5.946 0 0 0-.06-.928z",
    fill: "#d8c61e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.395,
    height: 38.143,
    rx: 5,
    transform: "translate(477.661 122.17)",
    fill: "#fff",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.661 122.456h47.395a5 5 0 0 1 5 5v.272h-57.395v-.272a5 5 0 0 1 5-5z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.917,
    cy: 0.917,
    rx: 0.917,
    ry: 0.917,
    transform: "translate(479.309 123.831)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.917,
    cy: 0.917,
    rx: 0.917,
    ry: 0.917,
    transform: "translate(481.601 123.831)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.917,
    cy: 0.917,
    rx: 0.917,
    ry: 0.917,
    transform: "translate(483.893 123.831)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.991 131.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.753,
    height: 11.753,
    rx: 3,
    transform: "translate(0 -1)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M13.749.887H35.26M13.749 3.105H35.26M13.749 5.322H35.26M13.749 7.54H26.39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.991 146.231)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.753,
    height: 11.753,
    rx: 3,
    transform: "translate(0 -1)",
    fill: "#93278f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.749.887H35.26",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M13.749 3.105H35.26M13.749 5.322H35.26M13.749 7.54H26.39"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.c74a3d1d2505ee6fa78d87400bfbe82e.svg";
export { ForwardRef as ReactComponent };